import { render, staticRenderFns } from "./myShopOrder.vue?vue&type=template&id=58dfeddf&scoped=true"
import script from "./myShopOrder.vue?vue&type=script&lang=js"
export * from "./myShopOrder.vue?vue&type=script&lang=js"
import style0 from "./myShopOrder.vue?vue&type=style&index=0&id=58dfeddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dfeddf",
  null
  
)

export default component.exports